<div class="modal-header">
    <span *ngIf="!mappingId" class="modal-header-title">{{ 'MAPPING.ADD_MAPPING' | translate }}</span>
    <span *ngIf="mappingId" class="modal-header-title">{{ 'MAPPING.EDIT_MAPPING' | translate }}</span>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
        <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
    </button>
</div>
<div class="modal-body">

    <form class="form" [formGroup]="form" #mappingForm (ngSubmit)="onCreate(); mappingForm.resetForm()"
        autocomplete="off">

        <div class="row">

            
                <div class="col-12">
                    <ff-input-lang 
                        label="{{ 'MAPPING.NAME_MAPPING' | translate }}"
                        hint="{{ 'MAPPING.NAME_MAPPING_ALL_LANGUAGE' | translate }}" 
                        fieldId="name" 
                        fieldName="name"
                        fieldType="text" 
                        [clearField]="ffInputLangParams.name.clearField"
                        [required]="ffInputLangParams.name.required" 
                        [inputValue]="mappingName"
                        (changeValue)="eventFnFF('name', $event)">
                    </ff-input-lang>
                </div>
            


            <div class="col-12 mb-3">

                <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
                    <div *ngIf="file.length == 0" class="dragarea" appDnd (fileDropped)="onFileDropped($event)">

                        <label class="drag-label" for="label"> Перетащите файл сюда</label>
                        <label class="size-label" for="label"> Максимальный размер файла: 100 МБ</label>

                        <ff-button-upload-files label="{{ 'UPLOAD_FILE' | translate }}" component="import"
                            (uploadedFiles)="onUploadedFile($event)">
                        </ff-button-upload-files>
                    </div>
                </div>

            </div>
        </div>

        <!-- <div class="row" *ngIf="file.length > 0 || !isCollapsed">


            <div class="col-6" *ngIf="permissionAccess.check('REFERENCES_ORGANIZATIONS')">

                <div class="form-group">
                    <label class="filter-label" for="org_id"> {{ 'ORGANIZATION.NAME' | translate }}:</label>
                    <ng-select
                        id="org_id" 
                        class="custom" 
                        clearAllText="{{ 'CLEAR' | translate }}"
                        notFoundText="{{ 'NO_DATA' | translate }}" 
                        bindLabel="name" bindValue="id"
                        formControlName="org_id" 
                        (search)="getOrganizations($event.term)"
                        placeholder="{{ 'ORGANIZATION.CHOOSE_ORGANIZATION' | translate }}" 
                        [multiple]="false"
                        [items]="organizations">
                    </ng-select>
                </div>

            </div>

        </div> -->


        <div class="reference-edge form-group" *ngIf="form.get('data')['controls'].length > 0">
            <label for="service-title" class="filter-label"><span> <b>{{ 'MAPPING.MAPPING_ELEM' | translate }}</b></span></label>
        </div>
        <div formArrayName="data" class="ref-child-data">

            <div class="scroll">

                <div *ngFor="let item of form.get('data')['controls']; let i = index;">
    
                    <div class="row row-data scroll-item" [formGroupName]="i">
    
                        <div class="col-6">
                            <div class="form-group">
                                <label class="filter-label" for="attribute_group_id">{{ 'DIALOG.GROUPS.NAME_GROUP_ATTRIBUTE' | translate }}
                                    <!-- <svg-icon src="/assets/images/icons/info-circle.svg" [stretch]="true" ngbTooltip="Обязательное для заполнения" tooltipClass="clue-name" [closeDelay]="300"></svg-icon> -->
                                </label>
                                <ng-select
                                    id="attribute_group_id" class="custom"
                                    clearAllText="{{ 'CLEAR' | translate }}"
                                    notFoundText="{{ 'NO_DATA' | translate }}"
                                    bindLabel="name" bindValue="id"
                                    formControlName="attribute_group_id"
                                    placeholder="{{ 'DIALOG.GROUPS.CHOOSE_GROUP' | translate }}"
                                    [multiple]="false"
                                    (change) = onListenerType(i)
                                    [items]="attributeGroups">
                                    <ng-template ng-option-tmp let-item="item">
                                        <div title="{{item.name}}">{{item.name}}</div>
                                    </ng-template>
                                </ng-select>
                                <div *ngIf="errorMessages">
                                    <div *ngFor="let item of errorMessages.attribute_group_id">
                                        <div class="text-error"
                                            *ngIf="validation(['data', i, 'attribute_group_id'], item.type)">
                                            {{ item.message | translate: item.options }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
    
                        <div class="col-6">
                            <div class="form-group">
                                <label class="filter-label" for="attribute_id">{{'NAME_ATTRIBUTES' | translate }}
                                    <!-- <svg-icon src="/assets/images/icons/info-circle.svg" [stretch]="true" ngbTooltip="Обязательное для заполнения" tooltipClass="clue-name" [closeDelay]="300"></svg-icon> -->
                                </label>
                                <ng-select id="attribute_id" class="custom"
                                    clearAllText="{{ 'CLEAR' | translate }}"
                                    notFoundText="{{ 'NO_DATA' | translate }}"
                                    bindLabel="name" bindValue="id"
                                    formControlName="attribute_id"
                                    placeholder="{{ 'ATTRIBUTES.CHOOSE_ATTRIBUTES' | translate }}"
                                    [multiple]="false"
                                    [items]="attributes[i]">
                                    <ng-template ng-option-tmp let-item="item">
                                        <div title="{{item.name}}">{{item.name}}</div>
                                    </ng-template>
                                </ng-select>
                                <div *ngIf="errorMessages">
                                    <div *ngFor="let item of errorMessages.attribute_id">
                                        <div class="text-error" *ngIf="validation(['data', i, 'attribute_id'], item.type)">
                                            {{ item.message | translate: item.options }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
    
                        <!-- <div class="col-3">
                                <div class="form-group">
                                    <label class="filter-label" for="attribute_id"><span class="star">*</span> Язык:</label>
                                    <ng-select 
                                    id="attribute_id" 
                                    class="custom" 
                                    clearAllText="{{ 'CLEAR' | translate }}"
                                    notFoundText="{{ 'NO_DATA' | translate }}" 
                                    bindLabel="name" 
                                    bindValue="id"
                                    formControlName="attribute_id"
                                    placeholder="Выберите язык"
                                    [multiple]="false" 
                                    [items]="langs">
                                    <ng-template ng-option-tmp let-item="item">
                                        <div title="{{item.name}}">{{item.name}}</div>
                                    </ng-template>
                                    </ng-select>
                                    <div *ngIf="errorMessages">
                                        <div *ngFor="let item of errorMessages.attribute_id">
                                            <div class="text-error" *ngIf="validation(['data', i, 'attribute_id'], item.type)">
                                                {{ item.message | translate: item.options }}
                                            </div>
                                        </div>
                                    </div>
                                </div>   
                            </div> -->
    
                        <div class="col-11 " [ngClass]="{'col-12 mb-4': form.get('data').value.length == 1}">
                            <div class="form-group">
                                <label for="foreign_attribute_id">{{ 'DIALOG.ATTRIBUTE.ATTRIBUTE_PARTY_SYSTEMIN_THIRD' | translate }}
                                    <!-- <svg-icon src="/assets/images/icons/info-circle.svg" [stretch]="true" ngbTooltip="Обязательное для заполнения" tooltipClass="clue-name" [closeDelay]="300"></svg-icon> -->
                                </label>
                                <input #element type="text" class="form-control" id="foreign_attribute_id" formControlName="foreign_attribute_id">   
                            </div>
                            <div *ngIf="errorMessages">
                                <div *ngFor="let item of errorMessages.foreign_attribute_id">
                                    <div class="text-error"
                                        *ngIf="validation(['data', i, 'foreign_attribute_id'], item.type)">
                                        {{ item.message | translate: item.options }}
                                    </div>
                                </div>
                            </div>
                        </div>
    
                        <div class="col-1" *ngIf="form.get('data').value.length > 1">
                            <div class="remove-reference-field">
                                <button type="button" class="btn btn-danger" (click)="removeMappingField(i)">
                                    <i class="bi bi-trash"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="data-loading" *ngIf="!mappingData && mappingId"> {{ 'LOADING_DATE' | translate }}...</div>

        <div class="row">
            <div class="col-12">
                <div class="btn-group">

                    <div class="add-reference-field" *ngIf="form.get('data').value">
                        <button type="button" class="btn btn-primary btn-sm" (click)="addMappingFields()">
                            <i class="bi bi-plus-circle"></i> {{ 'MAPPING.ADD_MAPPING_ELEM' | translate }}
                        </button>
                    </div>
                    <div class="add-reference-field" *ngIf="file.length == 0"> 
                        <button type="button" class="btn btn-primary btn-sm ring"  (click)="collapse.toggle()"
                            [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample" placement="right" ngbTooltip="С помощью файла Excel">
                            <i class="bi bi-file-earmark-excel"></i>
                        </button>

                    </div>

                </div>
            </div>


        </div>
    </form>

</div>
<div class="modal-footer btn-box">
    <button *ngIf="!mappingId" type="button" class="btn btn-primary btn-sm" (click)="onCreate()"
        [disabled]="form.invalid || !ffInputLang.valid || form.get('data')['controls'].length == 0">{{ 'SAVE'|
        translate}}</button>
    <button *ngIf="mappingId" type="button" class="btn btn-primary btn-sm" (click)="onUpdate()"
        [disabled]="form.invalid || !ffInputLang.valid || form.get('data')['controls'].length == 0">{{ 'SAVE'|
        translate}}</button>
    <button type="button" class="btn btn-light btn-sm" (click)="activeModal.dismiss(false)">{{ 'CLOSE' |
        translate}}</button>
</div>